<template>
  <svg width="960" height="190" viewBox="0 0 960 190" class="customer-ortho-elastic-graph"
    xmlns="http://www.w3.org/2000/svg">
    <!-- LINE FOR EVERY ARCH -->
    <polygon v-for="arch, index in active_arches" :id="'ortho_arch_' + index" :key="'arch_' + index"
      :points="arch_points[arch.id]" :style="arch_styles[arch.id]"
      style="fill:transparent;stroke-width:3;stroke-linejoin: round; stroke-linecap: round; transition: stroke .3s">
    </polygon>


    <!-- POLYLINE FOR EVERY ELASTIC -->
    <polygon v-for="elastic, index in active_elastics" :id="'ortho_elastic_' + index" :key="'elastic_' + index"
      :points="elastic_points[elastic.id]" :style="elastic_styles[elastic.id]"
      style="fill:transparent;stroke-width:3;stroke-linejoin: round; stroke-linecap: round; transition: stroke .3s">
    </polygon>
  </svg>
</template>

<script>
export default {
  props: ['elastics', 'arches', 'selected_tooth'],
  data() {
    return {
      upper_row_adults: [
        18, 17, 16, 15, 14, 13, 12, 11, // UPPER LEFT
        21, 22, 23, 24, 25, 26, 27, 28, // UPPER RIGHT
      ],
      lower_row_adults: [
        48, 47, 46, 45, 44, 43, 42, 41, // UPPER LEFT
        31, 32, 33, 34, 35, 36, 37, 38, // UPPER RIGHT
      ],
      teeth_coords: {
        // UPPER ROW - LEFT
        '18': '30 70',
        '17': '90 70',
        '16': '150 70',
        '15': '210 70',
        '14': '270 70',
        '13': '330 70',
        '12': '390 70',
        '11': '450 70',
        // UPPER ROW - RIGHT
        '21': '510 70',
        '22': '570 70',
        '23': '630 70',
        '24': '690 70',
        '25': '750 70',
        '26': '810 70',
        '27': '870 70',
        '28': '930 70',
        // LOWER ROW - LEFT
        '48': '30 120',
        '47': '90 120',
        '46': '150 120',
        '45': '210 120',
        '44': '270 120',
        '43': '330 120',
        '42': '390 120',
        '41': '450 120',
        // LOWER ROW - RIGHT
        '31': '510 120',
        '32': '570 120',
        '33': '630 120',
        '34': '690 120',
        '35': '750 120',
        '36': '810 120',
        '37': '870 120',
        '38': '930 120',
      }
    }
  },
  computed: {
    active_elastics() {
      return this.elastics.filter((elastic) => {
        return Boolean(elastic.is_current) && elastic.type == 'elastic';
      });
    },
    active_arches() {
      return this.arches.filter((arch) => {
        return Boolean(arch.is_active);
      });
    },
    elastic_styles() {
      let ret = {};
      const teeth = ['tooth_1', 'tooth_2', 'tooth_3', 'tooth_4'];

      this.active_elastics.forEach((elastic) => {
        let selected = false;

        teeth.forEach((t) => {
          const c = elastic[t]
          if (c && this.selected_tooth.includes(c)) {
            selected = true;
          }
        });

        ret[elastic.id] = {
          stroke: selected ? 'var(--theme-color)' : '#212529',
        };
      });

      return ret;
    },
    arch_styles() {
      let ret = {};

      this.active_arches.forEach((arch) => {
        let selected = false;

        if (arch.arch == 'upper') {
          this.selected_tooth.forEach((t) => {
            if (this.upper_row_adults.includes(Number(t))) {
              selected = true;
            }
          });
        } else {
          this.selected_tooth.forEach((t) => {
            if (this.lower_row_adults.includes(Number(t))) {
              selected = true;
            }
          });
        }

        ret[arch.id] = {
          stroke: selected ? 'var(--theme-color)' : '#212529',
        };
      });

      return ret;
    },
    elastic_points() {
      let ret = {};
      const teeth = ['tooth_1', 'tooth_2', 'tooth_3', 'tooth_4'];

      this.active_elastics.forEach((elastic) => {
        let points = [];

        teeth.forEach((t) => {
          const c = elastic[t]
          if (c) {
            points.push(this.teeth_coords[c]);
          }
        });

        ret[elastic.id] = points.join(', ');
      });
      return ret;
    },
    arch_points() {
      let ret = {};

      const upper_arches = this.active_arches.filter((a) => {
        return a.arch == 'upper';
      });

      const lower_arches = this.active_arches.filter((a) => {
        return a.arch == 'lower';
      });

      upper_arches.forEach((arch, index) => {
        let points = [];
        const offset = (60 - (6 * index));
        points.push(`30 ${offset}, 930 ${offset}`);
        ret[arch.id] = points.join(', ');
      });

      lower_arches.forEach((arch, index) => {
        let points = [];
        const offset = (130 + (6 * index));
        points.push(`30 ${offset}, 930 ${offset}`);
        ret[arch.id] = points.join(', ');
      });

      return ret;
    }
  }
}
</script>

<style lang="scss">
.customer-ortho-elastic-graph {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;
}
</style>
